import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import LanguageIcon from '@components/LanguageIcon';
import { createLanguageFilters, matchesLanguageCode } from '@utils/supportedLanguages';
import { contentTypes, messageTypes } from '@utils';
import { NO_APP_USER_SELECTED } from '@constants';
import { selectAppUsersById } from '@redux/appUsers/reducers';

export function Audience({ audienceDisplay, t, users }) {
  const [, appUsers] = useSelector(selectAppUsersById('ubiquity', users));

  if (audienceDisplay === NO_APP_USER_SELECTED) {
    return t('cards:ScheduledMessagesList.noAudience');
  }

  if (appUsers?.length > 0) {
    return appUsers.map(appUser => appUser.displayName || appUser.id).join(', ');
  }
  return audienceDisplay;
}

export default t => [
  {
    className: 'language-column',
    title: t('cards:SentMessagesList.columns.language.title'),
    dataIndex: ['metadata', 'language'],
    key: 'language',
    render: language => {
      return <LanguageIcon language={language} />;
    },
    width: 150,
    filters: createLanguageFilters(t),
    onFilter: (value, record) => matchesLanguageCode(record.metadata.language, value),
  },
  {
    title: t('cards:SentMessagesList.columns.type.title'),
    dataIndex: ['metadata', 'type'],
    key: 'metadata-type',
    render: type => (
      <Tooltip placement="bottom" title={t(contentTypes[type.toUpperCase()].label)}>
        <FontAwesomeIcon size="lg" icon={contentTypes[type.toUpperCase()].icon} />
      </Tooltip>
    ),
    width: 130,
    sorter: (a, b) => a.metadata.type.localeCompare(b.metadata.type),
    filters: messageTypes.map(type => ({ text: t(contentTypes[type].label), value: type })),
    onFilter: (value, record) => record.metadata.type.toUpperCase() === value,
  },
  {
    title: t('cards:SentMessagesList.columns.dateSent'),
    dataIndex: 'lastSentDatetime',
    key: 'lastSentDatetime-date',
    width: 200,
    ellipsis: true,
    sorter: (a, b) => a.lastSentDatetime > b.lastSentDatetime,
    render: dateString => {
      const sentMoment = moment(dateString);

      return `${sentMoment.format('L')} ${sentMoment.format('LT')}`;
    },
  },
  {
    title: t('cards:SentMessagesList.columns.audience'),
    dataIndex: 'audienceDisplay',
    key: 'audience',
    ellipsis: true,
    render: (audienceDisplay, record) => (
      <Audience audienceDisplay={audienceDisplay} t={t} users={record.users} />
    ),
  },
  {
    title: t('cards:SentMessagesList.columns.title'),
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
  },
];
